<template>
  <div id="app">
    <LoadingComponent />
    <div id="nav">
      <Header />
    </div>
    <div id="main">
        <router-view/>
    </div>
    <div id="nav">
      <Footer />
    </div>
  </div>
</template>
<script>
import Header from  './components/Header.vue'
import Footer from  './components/Footer.vue'
import LoadingComponent from '@/components/LoadingComponent.vue'
import Ads from 'vue-google-adsense'
export default {
  components:{
    Header,
    Footer,
    LoadingComponent,
    Ads
  }
}
</script>


<style>
#app{
  padding-top:64px;
  padding-bottom: 64px;
}
#main{
  max-width: 1200px;
  margin: auto;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.ad_container{
  padding:10px;
}
</style>
